import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VIcon,{attrs:{"size":_vm.size,"color":_vm.color}},[_vm._v(_vm._s(_vm.svgPath))])}
var staticRenderFns = []

export { render, staticRenderFns }